export interface IVariant {
  id: number;
  variant_name: string;
  is_blocked: boolean;
  is_valid: boolean;
  product_varinat?: number | null;
}
